import { Component, DestroyRef, Inject, ViewChild, inject, ElementRef, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServicesService } from 'src/services/services.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-mycatalogue',
  templateUrl: './mycatalogue.component.html',
  styleUrls: ['./mycatalogue.component.scss']
})
export class MycatalogueComponent {

  StallForm: FormGroup;
  private destroyRef = inject(DestroyRef);

  stall_id: any;
  stall_num: any;

  imagefileURL: any | ArrayBuffer;
  imagePath: any;
  isOld1: boolean = false;
  image_name: any;
  main: any;
  user_mobile: any;
  user_id: any;
  shopExists: any;
  owner_number: any;
  loading = true;
  so_id: any;

  constructor(
    private fb: FormBuilder,
    private service: ServicesService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {

    this.StallForm = this.fb.group({
      image_name: new FormControl(''),
      owner_name: new FormControl('', [Validators.required]),
      owner_number: new FormControl('', [Validators.required]),
      company_name: new FormControl('', [Validators.required]),
      email: new FormControl(''),
      address: new FormControl('', [Validators.maxLength(250)]),
      website: new FormControl('', [Validators.maxLength(250)]),
      youtube: new FormControl('', [Validators.maxLength(250)]),
      facebook: new FormControl('', [Validators.maxLength(250)]),
      instagram: new FormControl('', [Validators.maxLength(250)]),
      notes: new FormControl('')
    });
  }

  ngOnInit(): void {
    this.user_id = sessionStorage.getItem('User_ID');
    this.getUserById(this.user_id);
  }

  getUserById(user_id: any) {
    this.service.get_user_by_id(user_id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data: any) => {

        this.loading = false; // only show form if not redirecting
        this.main = data.data;
        this.owner_number = this.main?.[0]?.user_mobile;
        this.so_id = data.so_id;

      });
  }

  previewpimage(files: any) {
    if (files.length === 0) return;

    let mimeType = files[0].type;
    if (!mimeType.match(/image\/*/)) {
      this.toastr.error('Only images are supported.');
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      this.imagefileURL = reader.result;

      this.service.uploadimage(this.imagefileURL, "/0/stall").subscribe((data: any) => {
        this.imagePath = data['image_name'];
        this.isOld1 = false;

        this.StallForm.patchValue({ image_name: this.imagePath });
      });
    };
  }

  openStallUsers(so_id: any) {
    this.router.navigate(['/admin/stallsusers/' + so_id]);
  }

  openLink(so_id: any) {
    const url = `https://aieventzo.com/product_catalogue.html?so_id=${so_id}`;
    window.open(url, '_blank'); // Opens the link in a new tab
  }

  copyLink(so_id: any) {
    const url = `https://aieventzo.com/product_catalogue.html?so_id=${so_id}`;

    navigator.clipboard.writeText(url).then(() => {
      this.toastr.success("Link copied to clipboard!");
    }).catch(() => {
      this.toastr.error("Failed to copy link!");
    });
  }


  onFormSubmit() {
    if (!this.StallForm.valid) {
      this.toastr.error("Please fill required fields");
      return;
    }

    const ExistedImage = this.isOld1 ? this.image_name : this.imagePath;
    this.StallForm.patchValue({ image_name: ExistedImage });

    this.service.add_stall_owner(this.StallForm.value)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: any) => {
        if (res.flag == true) {
          this.toastr.success(res.msg);
          window.location.reload();
        } else if (res.flag == false) {
          this.toastr.error(res.msg);
        }
      });

  }

}
